<template>
	<div class="company-index max-content">
		<top title="企业主页" :color="color"></top>
		<div class="introduction">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item,key,index) in swiperImg" :key="index" @click="clickSwiperImg(item.url)">
					  <img :src="item.banner" alt="">
					</van-swipe-item>
			    </van-swipe>
			</div>
		</div>
		<div class="sessionDetails">
			<div class="dateList">
				<div class="item" v-for="item in scheduleDate" :key="item">
					<a href="javascript:void(0)" @click="switchDate(item)" :class="item==active?'active':''">
						{{item}}
					</a>
				</div>
			</div>
			<div class="dateMeeting" :class="'both'" v-if="scheduleList">
				<div class="item" v-for="(item,index) in scheduleList" :key="index">
					<div class="cover" v-if="item.company_area_link_url" @click="clickSwiperImg(item.company_area_link_url)">
						<img :src="item.company_area_image" alt="" >
						<p class="area-name">{{item.company_area_name}}</p>
						<p class="time">
							<van-icon name="clock-o" >
							</van-icon>
							{{formatTime(item.start_at)}}
						</p>
					</div>   
					<router-link :to="{path:'/vascularNews/company/live',query:{'meeting_id':meeting_id,'id':item.session_id,'chapter_id':item.chapter_id,form_id:form_id,company_area_id:company_area_id}}" v-else>
						<div class="cover">
							<img :src="item.company_area_image" alt="" >
                            <p class="area-name">{{item.company_area_name}}</p>
                            <p class="time">
				                <van-icon name="clock-o" >
                                </van-icon>
                                {{formatTime(item.start_at)}}
                            </p>
						</div>   
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import Register from "../../components/Users/Register.vue"
	import {MeetingsCarousel,CompanyAreaDetail,CompanySchedule} from '../../../config/interface.js'
	import { ImagePreview } from 'vant'    //预览图片   使用的函数调用
	import Top from '../components/Top'
	export default{
        components:{
			Top
		},
		data(){
			return{
				meeting_id:0,	//会议id
                company_area_id:'', //企业专区id
				meetingInfo:{},   //会议信息
				meeting_dates:[],   //日期会议
				liveList:[],     //会议
				swiperImg:{},     //轮播图
				active:0,
				scheduleDate:[],
				scheduleList:[],
				meetingSchedule:[],
				form_id:'',
				color:'#ffffff'
			}
		},
		created(){
        },
		mounted(){
			this.meeting_id=this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id;
            this.company_area_id=this.$route.query.company_area_id;
			this.getSchedule();
			this.getCompanyCarousel();
			
		},
		methods:{
			getSchedule(){
				const url=CompanySchedule;
				let params={
					meeting_id:this.meeting_id,
					company_area_id:this.company_area_id

				}
				const method="POST";
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.meetingSchedule=data;
						this.scheduleDate=Object.keys(this.meetingSchedule);
						this.switchDate(this.scheduleDate[0]);
					}
				})
			},
			//切换日期
			switchDate(date){
				this.active=date;
				setTimeout(()=>{
					this.scheduleList=this.meetingSchedule[date];
				},500)
			},
			//处理日期  09:30样式
			handleDate(date){
				let time=(date.split(' ')[1]).split(':')
				return time[0]+':'+time[1];
			},
			//跳转链接
			skipLink(item){
				if(item.url.match(/\.(jpeg|jpg|gif|png)$/)){
					ImagePreview({
						images:[item.url],
						closeable:true,
						showIndex:false
						});
				}else{
					window.location.href=item.url;
				}
				
			},
			//会议轮播
			getCompanyCarousel(){
				const url=CompanyAreaDetail;
				let params={
					meeting_id:this.meeting_id,
					company_area_id:this.company_area_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data.banners;
						document.title=data.name;
						if(common.is_weixin()){
							document.title=data.share_title;
							common.wxShare(data.share_title,data.share_sub_title,data.share_img);
						}
						if(data.has_form==1){
							this.form_id=data.form_id
						}
						// this.color=data.top_color;
						if(data.top_color){
							this.color=data.top_color
						}
						else{
							this.color='#901D22'
						}
					}
				})
			},
			clickSwiperImg(url){
				window.location.href=url;
			},
			formatTime(str){
				if(str){
					return str.slice(0,16);
				}
				return ''
			}
		}
	}
</script>
<style lang="scss">
	.company-index{
		position: relative;
		.introduction{
			padding:14px 12px;
			.cover{
				img{
					width:100%;
					border-radius:5px;
				}
			}
        }
		.sessionDetails{
			padding:0px 12px 14px;
			h3{
				font-size:17px;
				color:$color-black;
				line-height:30px;
			}
			h4{
				font-size:15px;
				color:$color-black;
				line-height:30px;
			}
			.dateList{
				padding:15px 0px;
				display: flex;
				flex-wrap: wrap;
				.item{
					width:25%;
					margin-bottom:5px;
				}
				a{

					background:#ececec;
					display:block;
					border-radius: 5px;
					font-size:13px;
					color:$color-gray;
					margin:0 5px;
					text-align: center;
					padding:5px 0;
				}
				a.active{
					color:white;
					background: $color-main;
				}
			}
			.dateMeeting{
				position: relative;
			}
			.dateMeeting.both{
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				.item{
					width:48%;
                    border-radius: 10px;
                    background: white;
					margin-bottom:10px ;
                    p{
                        display: flex;
				        align-items: center;
				        margin:0 auto 5px;
				        padding:5px;
				        color:$color-gray;
				        font-size:12px;
                    }
					.area-name{
                   		padding-left:5px;
						color: $color-black;
						font-size: 16px;
						line-height: 25px;
                    }
                    img{
                        border-radius: 10px 10px 0 0;
                    }
				}
				
			}
			.cover{
				position:relative;
			    margin:0 0 12px 0;
                border-radius: 10px;
				img{
					width:100%;
				}
				span{
					color:#fff;
					/*font-weight:700;*/
					font-size:15px;
					letter-spacing:1px;
					position:absolute;
					left:20px;
					top:50%;
					transform:translate(0,-50%);
				}
			}
			.details{
				.item{
					@include flex(row);
					color:$color-gray;	
					font-size:12px; 
					letter-spacing:1px;  /*no*/
					letter-spacing:.46px;
					margin-bottom: 15px;
					p,span{
						margin-right:5px;
						line-height:20px;
						min-width:65px;
						text-align: justify;
					}
					p{
						flex:1;
					}
				}
			}

		}
		.van-popup{
			border-radius: 11px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Company/Index.vue